import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "documentation-content p-3 my-3 border-rounded" }
const _hoisted_2 = { class: "flex my-1 text-sm" }
const _hoisted_3 = { class: "mr-1" }
const _hoisted_4 = { class: "dark-medium ml-1" }
const _hoisted_5 = ["innerHTML"]

import { onMounted, toRefs } from 'vue';
import { useCalendarStore } from '@/store';
import { PastDocumentationGoal } from './index';
import { PastResultInterface } from '@/types';
import { useDateTime } from '@/composables';

interface Props {
  data: PastResultInterface;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'PastDocumentationCard',
  props: {
    data: {}
  },
  setup(__props: any) {

const calendarStore = useCalendarStore();

const props = __props;

const { data } = toRefs(props);

onMounted(() => init());

const formatTimes = (dates: PastResultInterface['event']['time']) => {
  const startTime = new Intl.DateTimeFormat('default', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(useDateTime().fromUTCStringToLocalDate(dates[0]));

  const endTime = new Intl.DateTimeFormat('default', {
    hour: 'numeric',
    minute: 'numeric',
  }).format(useDateTime().fromUTCStringToLocalDate(dates[1]));
  return `${startTime.toLowerCase().replace(' ', '')} - ${endTime.toLowerCase().replace(' ', '')}`;
};

const init = () => {
  calendarStore.selectedEvent.event_process_type = 'this';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("b", _hoisted_3, _toDisplayString(_unref(data).event.date), 1),
      _cache[0] || (_cache[0] = _createTextVNode(" - ", -1)),
      _createElementVNode("div", _hoisted_4, _toDisplayString(formatTimes(_unref(data).event.time)), 1)
    ]),
    _createElementVNode("p", {
      class: "my-2 text-justify",
      innerHTML: _unref(data).result.notes
    }, null, 8, _hoisted_5),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).result.treatment_goal_measurements, (goal) => {
      return (_openBlock(), _createBlock(_unref(PastDocumentationGoal), {
        key: goal.id,
        data: goal
      }, null, 8, ["data"]))
    }), 128))
  ]))
}
}

})